import React from 'react';
import {
  IInvoiceBundle,
  IRouteScreenProps,
  ISupplierUserProfile,
} from 'constants/interfaces';
import {apiGetInvoiceBundles} from 'constants/Api';
import {
  Box,
  Button,
  ButtonGroup,
  Snackbar,
  Typography,
} from '@material-ui/core';
import {connect} from 'react-redux';
import {Route} from 'react-router-dom';
import {KhulaSupplierTable} from 'components/Table/KhulaSupplierTable';
import moment from 'moment';
import {
  OrderBundleTableFilters,
  orderBundleTableHeaders,
  orderBundleTableRows,
} from 'screens/Dashboard/OrderBundles/OrderBundleTableSetup';

type OrderBundlesProps = IRouteScreenProps & {
  user: ISupplierUserProfile;
};

class OrderBundles extends React.Component<OrderBundlesProps> {
  state: {
    isLoading: boolean;
    isRefreshing: boolean;
    showRefreshedSnackbar: boolean;
    fetchSize: number;
    invoiceBundles: IInvoiceBundle[];
  } = {
    isLoading: true,
    isRefreshing: false,
    showRefreshedSnackbar: false,
    fetchSize: 20,
    invoiceBundles: [],
  };

  componentDidMount() {
    this.loadOrderBundles();
  }

  async loadOrderBundles() {
    this.setState({isLoading: true}, () => {
      return apiGetInvoiceBundles(this.state.fetchSize)
        .then((invoiceBundles: IInvoiceBundle[]) => {
          this.setState({invoiceBundles});
        })
        .catch((error) => {
          alert('Error loading order bundles. Please try again later');
          console.error(error);
        })
        .finally(() => this.setState({isLoading: false, isRefreshing: false}));
    });
  }

  async refreshOrderBundles() {
    this.setState({isRefreshing: true}, () => {
      return apiGetInvoiceBundles(this.state.fetchSize)
        .then((invoiceBundles: IInvoiceBundle[]) => {
          this.setState({invoiceBundles});
        })
        .catch((error) => {
          alert('Error loading order bundles. Please try again later');
          console.error(error);
        })
        .finally(() => this.setState({isLoading: false, isRefreshing: false}));
    });
  }

  handleFetchSizeUpdate(size?: number) {
    this.setState({fetchSize: size}, () => {
      this.refreshOrderBundles();
    });
  }

  render() {
    const {
      isLoading,
      isRefreshing,
      showRefreshedSnackbar,
      fetchSize,
      invoiceBundles,
    } = this.state;

    return (
      <>
        <div className="table-screen orders-container">
          <Typography variant="h5" className="page-title">
            Order Bundles
          </Typography>
          <Route
            render={({history}) => (
              <div className="orders-section">
                <Box className="actions-row">
                  <div style={{flex: 1}} />
                  <ButtonGroup variant="text">
                    {[20, 50, undefined].map((size, index) => (
                      <Button
                        key={index}
                        variant={fetchSize === size ? 'contained' : 'text'}
                        disabled={isLoading || isRefreshing}
                        disableElevation
                        onClick={() => this.handleFetchSizeUpdate(size)}
                        size={'small'}
                      >
                        {size || 'All'}
                      </Button>
                    ))}
                  </ButtonGroup>
                </Box>
                <OrderBundleTable
                  orderBundles={invoiceBundles}
                  isLoading={isLoading}
                  isRefreshing={isRefreshing}
                  onRefresh={() => this.refreshOrderBundles()}
                />
                <Box mt={1}>
                  <Typography variant={'caption'}>
                    Last updated: {moment().fromNow()}
                  </Typography>
                </Box>
                <Snackbar
                  anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                  open={showRefreshedSnackbar}
                  onClose={() => this.setState({showRefreshedSnackbar: false})}
                  autoHideDuration={3000}
                  message="Order bundles refreshed"
                />
              </div>
            )}
          />
        </div>
      </>
    );
  }
}

function OrderBundleTable(props: {
  orderBundles: IInvoiceBundle[];
  isLoading: boolean;
  isRefreshing: boolean;
  onRefresh: VoidFunction;
}) {
  const {orderBundles, isLoading, isRefreshing, onRefresh} = props;

  // const mapRowToOrderBundle = (row: Row) =>
  //   // @ts-ignore
  //   orderBundles.find((bundle) => bundle.id == row.id);

  return (
    <KhulaSupplierTable
      headers={orderBundleTableHeaders()}
      rows={orderBundleTableRows(orderBundles, (bundle) => {})}
      filtersGroups={OrderBundleTableFilters}
      isLoading={isLoading}
      isRefreshing={isRefreshing}
      onRefresh={onRefresh}
      onRowSelect={(row) => {
        // const bundle = mapRowToOrderBundle(row);
      }}
    />
  );
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps)(OrderBundles);
